import React from 'react';

import Collapse from '@material-ui/core/Collapse';

import FieldActivitiesDetails from './FieldActivitiesDetails';

const ActivitiesCollapse = ({ field, open }) => {
  return (
    <Collapse in={open} timeout="auto" unmountOnExit>
      <FieldActivitiesDetails field={field} />
    </Collapse>
  );
};

export default ActivitiesCollapse;
